import { Outlet } from "react-router-dom";

import { useIframeInitialization } from "@src/features/iframe";
import { Toaster } from "@src/shared/components/ui/sonner";
import { RouterBridge } from "@src/shared/providers/routerBridge";

export default function Root() {
  useIframeInitialization();

  return (
    <>
      <RouterBridge />
      <Outlet />
      <Toaster />
    </>
  );
}
